export default __webpack_public_path__ + "static/media/PhysicalDescriptions_16.cfda1ee8.png";